<template>
  <!--Page Container View Mode-->
  <div class="sentio-slide view-slide">
    <img src="../../assets/images/field-manager.png">
    <div class="slide-text-part" v-bind:class="{ 'more-opened': moreContentDisplayed }">
      <img src="../../assets/images/field-manager-logo.svg"  v-on:click="select($event)">
      <span class="minimized-indicator">
        <div class="tooltip">
          <label class="opened">Opened</label>
          <label class="closed">Closed</label>
        </div>
      </span>
      <div class="clearfix"></div>
      <p>Customer success starts here...<br/>
      Identify and organize fields for seed selection. By combining the knowledge of field specific soils and historical weather, seed products are rated for confidence using the unique gauge approach for quick learning.  Reseller specific reports are simple and easy to generate and share.
      </p>
      <div class="text-center">
        <button v-on:click="select($event)">OPEN APP</button>
      </div>
      <div class="clearfix"></div>
      <!-- <button class="more-icon" @click.stop="moreContentClicked">
        <i class="fa fa-chevron-down"></i>
      </button>
      <div class="more-content">
        <h2>More Content</h2>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.</p>
        <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
        <button>Action Button</button>
        <button class="close-more" @click.stop="closeMoreContent">Close</button>
      </div> -->
    </div>
  </div>
</template>

<script>
// import portalAPI from "../../services/portalService";
import baseAppComponent from "./baseAppComponent.vue";

// let pAPI = new portalAPI();

export default {
  extends: baseAppComponent,
  name: "FieldManagerComponent",
  data() {
    return {
    };
  },
  methods: {
  }
};
</script>

